var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminChange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.682,
    height: 39.469,
    viewBox: "0 0 41.682 39.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6150",
    "data-name": "Group 6150",
    transform: "translate(2.047 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47429",
    "data-name": "Path 47429",
    d: "M22.795,2.816,20.318.339a1.156,1.156,0,0,0-1.635,1.635l.507.507A14.8,14.8,0,0,0,4.72,17.257a1.156,1.156,0,1,0,2.313,0A12.482,12.482,0,0,1,19.182,4.794l-.5.5a1.156,1.156,0,0,0,1.635,1.635L22.8,4.451A1.156,1.156,0,0,0,22.795,2.816ZM38.078,21.055a1.156,1.156,0,0,0-1.156,1.156A12.482,12.482,0,0,1,24.773,34.675l.5-.5a1.156,1.156,0,0,0-1.635-1.635L21.16,35.018a1.157,1.157,0,0,0,0,1.635l2.477,2.477a1.156,1.156,0,1,0,1.635-1.635l-.507-.507a14.8,14.8,0,0,0,14.47-14.776,1.156,1.156,0,0,0-1.156-1.156Z",
    transform: "translate(-3.216 0)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6151",
    "data-name": "Group 6151",
    transform: "translate(22.619 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47418",
    "data-name": "Path 47418",
    d: "M18.766,17.677a3.554,3.554,0,0,0-1.794-2.842,12.352,12.352,0,0,0-6.714-1.723,12.352,12.352,0,0,0-6.714,1.723A3.554,3.554,0,0,0,1.75,17.677v1.2a1.411,1.411,0,0,0,1.411,1.411H17.355a1.409,1.409,0,0,0,1.411-1.411Z",
    transform: "translate(-1.75 -3.266)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 4.565,
    cy: 4.565,
    r: 4.565,
    transform: "translate(3.943)",
    fill: "#4165f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6152",
    "data-name": "Group 6152",
    transform: "translate(-2.047 20.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47418-2",
    "data-name": "Path 47418",
    d: "M18.766,17.677a3.554,3.554,0,0,0-1.794-2.842,12.352,12.352,0,0,0-6.714-1.723,12.352,12.352,0,0,0-6.714,1.723A3.554,3.554,0,0,0,1.75,17.677v1.2a1.411,1.411,0,0,0,1.411,1.411H17.355a1.409,1.409,0,0,0,1.411-1.411Z",
    transform: "translate(-1.75 -3.266)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45-2",
    "data-name": "Ellipse 45",
    cx: 4.565,
    cy: 4.565,
    r: 4.565,
    transform: "translate(3.943 0)",
    fill: "#4165f6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminChange);
export default __webpack_public_path__ + "static/media/adminChange.f6a15597dc2240b3eea5ababe76727ab.svg";
export { ForwardRef as ReactComponent };